import {
  UPDATE_ASSIGNMENT_CONFIG_USE_CASE,
  COMPLETE_ASSIGNMENT_USE_CASE,
  CompleteAssignmentUseCase,
  GET_EDIT_ASSIGNMENT_CONFIG_USE_CASE,
  UpdateAssignmentConfigUseCase,
  ASSIGNMENT_REPOSITORY,
  UPDATE_ASSIGNMENT_ACCESS_USE_CASE,
  IAssignmentRepository,
  GetAssignmentsUseCase,
  GetAssignmentByIdUseCase,
  GetAttendeesUseCase,
  DeleteAssignmentUseCase,
  GET_ASSIGNMENTS_USE_CASE,
  DELETE_ASSIGNMENT_USE_CASE,
  GET_ASSIGNMENT_BY_ID_USE_CASE,
  GET_ATTENDEES_USE_CASE,
  CREATE_PRACTICE_ASSIGNMENT_USE_CASE,
  CreatePracticeAssignmentUseCase,
  GET_ATTENDEE_BY_ID_USE_CASE,
  GetAttendeeByIdUseCase,
  IPracticeAssignmentRepository,
  PRACTICE_ASSIGNMENT_REPOSITORY,
  PUBLISH_SCORE_USE_CASE,
  PublishScoreUseCase,
  CREATE_EXAMINATION_ASSIGNMENT_USE_CASE,
  EXAMINATION_ASSIGNMENT_REPOSITORY,
  CreateExaminationAssignmentUseCase,
  IExaminationAssignmentRepository,
  UPDATE_ASSIGNMENT_USE_CASE,
  UpdateAssignmentUseCase,
  COMPLETE_PRACTICE_ASSIGNMENT_USE_CASE,
  CompletePraticeAssignmentUseCase,
} from '@module/assignment';

import { FORM_RELEASE_REPOSITORY, IFormReleaseRepository } from '@module/form';
import { GET_CLASS_DASHBOARD_ASSIGNMENTS_USE_CASE } from '../../redux/classes/class-dashboard.constants';

export const assignmentUseCaseProviders = [
  {
    provide: COMPLETE_ASSIGNMENT_USE_CASE,
    useFactory: (repository: IAssignmentRepository) => new CompleteAssignmentUseCase(repository),
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: GET_EDIT_ASSIGNMENT_CONFIG_USE_CASE,
    useFactory: (repository: IAssignmentRepository) => new GetAssignmentByIdUseCase(repository),
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: UPDATE_ASSIGNMENT_CONFIG_USE_CASE,
    useFactory: (
      practice: IPracticeAssignmentRepository,
      examination: IExaminationAssignmentRepository,
    ) => new UpdateAssignmentConfigUseCase(practice, examination),
    inject: [PRACTICE_ASSIGNMENT_REPOSITORY, EXAMINATION_ASSIGNMENT_REPOSITORY],
  },
  {
    provide: GET_CLASS_DASHBOARD_ASSIGNMENTS_USE_CASE,
    useFactory: (repository: IAssignmentRepository) => new GetAssignmentsUseCase(repository),
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: UPDATE_ASSIGNMENT_ACCESS_USE_CASE,
    useFactory: (repository: IAssignmentRepository) => new UpdateAssignmentUseCase(repository),
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: GET_ASSIGNMENT_BY_ID_USE_CASE,
    useFactory: (assignmentRepository: IAssignmentRepository) => {
      return new GetAssignmentByIdUseCase(assignmentRepository);
    },
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: GET_ASSIGNMENTS_USE_CASE,
    useFactory: (assignmentRepository: IAssignmentRepository) => {
      return new GetAssignmentsUseCase(assignmentRepository);
    },
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: DELETE_ASSIGNMENT_USE_CASE,
    useFactory: (assignmentRepository: IAssignmentRepository) => {
      return new DeleteAssignmentUseCase(assignmentRepository);
    },
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: GET_ATTENDEES_USE_CASE,
    useFactory: (assignmentRepository: IAssignmentRepository) => {
      return new GetAttendeesUseCase(assignmentRepository);
    },
    inject: [ASSIGNMENT_REPOSITORY],
  },
  // Practice
  {
    provide: CREATE_PRACTICE_ASSIGNMENT_USE_CASE,
    useFactory: (
      practiceAssignmentRepository: IPracticeAssignmentRepository,
      formReleaseRepository: IFormReleaseRepository,
    ) => {
      return new CreatePracticeAssignmentUseCase(
        practiceAssignmentRepository,
        formReleaseRepository,
      );
    },
    inject: [PRACTICE_ASSIGNMENT_REPOSITORY, FORM_RELEASE_REPOSITORY],
  },
  // Examination assignment
  {
    provide: CREATE_EXAMINATION_ASSIGNMENT_USE_CASE,
    useFactory: (
      examinationAssignmentRepository: IExaminationAssignmentRepository,
      formReleaseRepository: IFormReleaseRepository,
    ) => {
      return new CreateExaminationAssignmentUseCase(
        examinationAssignmentRepository,
        formReleaseRepository,
      );
    },
    inject: [EXAMINATION_ASSIGNMENT_REPOSITORY, FORM_RELEASE_REPOSITORY],
  },
  {
    provide: GET_ATTENDEE_BY_ID_USE_CASE,
    useFactory: (assignmentRepository: IAssignmentRepository) => {
      return new GetAttendeeByIdUseCase(assignmentRepository);
    },
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: PUBLISH_SCORE_USE_CASE,
    useFactory: (examinationAssignmentRepository: IExaminationAssignmentRepository) => {
      return new PublishScoreUseCase(examinationAssignmentRepository);
    },
    inject: [EXAMINATION_ASSIGNMENT_REPOSITORY],
  },
  {
    provide: UPDATE_ASSIGNMENT_USE_CASE,
    useFactory: (assignmentRepository: IAssignmentRepository) => {
      return new UpdateAssignmentUseCase(assignmentRepository);
    },
    inject: [ASSIGNMENT_REPOSITORY],
  },
  {
    provide: COMPLETE_PRACTICE_ASSIGNMENT_USE_CASE,
    useFactory: (practiceAssignmentRepository: IPracticeAssignmentRepository) => {
      return new CompletePraticeAssignmentUseCase(practiceAssignmentRepository);
    },
    inject: [PRACTICE_ASSIGNMENT_REPOSITORY],
  },
];
